import type { PaymentFailure } from '@/shared/types/api';

export const PAYMENT_TERMINAL_STATES = {
  IDLE: 'idle',
  WAITING: 'waiting',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type PaymentTerminalState =
  (typeof PAYMENT_TERMINAL_STATES)[keyof typeof PAYMENT_TERMINAL_STATES];

export interface PaymentTerminalError extends Error {
  category?: PaymentFailure['category'];
  code?: string;
  declineCode?: string | null;
  failure?: PaymentFailure | null;
  paymentStatus?: string;
}

export interface PaymentTerminalPublicApi<Store = unknown, Router = unknown> {
  _isNavigating: boolean;
  _isUnmounted: boolean;
  _paymentAttemptCount: number;
  _paymentStartTime: number | null;
  readonly isPaymentError: boolean;
  readonly isPaymentSuccessful: boolean;
  readonly isWaitingForPayment: boolean;
  getTotalSumFormatted: () => string;
  launch: () => void;
  onCancelClick: () => void;
  onExitSessionClick: () => Promise<void>;
  onPopupContinueClick: () => void;
  onPopupExitClick: () => Promise<void>;
  onRetryClick: () => void;
  router: Router;
  showTerminalCancelledPopup: boolean;
  state: PaymentTerminalState;
  store: Store;
}
